export default {"src":"/_next/static/media/dotsLeft.35e34ffa.svg","height":349,"width":339,"blurWidth":0,"blurHeight":0};